

app.controller('CIF3-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {
    $scope.CIFInvestor = {}


    $scope.chkquestionfatca = true;
    $scope.chkquestion1 = false;
    $scope.chkquestion2 = false;
    $scope.chkquestion3 = false;
    $scope.chkquestion4 = false;

    $scope.print = function () {
        $scope.prepareData();
    }



    var allPromise = $q.all([
       $http({
           method: 'GET',
           url: '/service/client.svc/GetCIFLookup',
           cache: true,
       }).then(function (data) {
           $scope.ListLookup = data.data.d;
           if ($scope.ListLookup) {
               $scope.ListInvestmentObjectives = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);
               $scope.ListRisk = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Risk' }, true);
            
           }
       }, function (error) { }),

       $http({
           method: 'POST',
           url: '/service/client.svc/retrieveSession',
       }).then(function (data) {
           if (!data.data.d) {
               $http({
                   method: 'GET',
                   url: '/service/client.svc/SignOut',
               }).then(function (data) {
                   if (data.data.d == true) {
                       $window.location.href = "#/login";
                       $window.location.reload();
                   }
               }, function (error) { })
           }
           else
               $scope.currentUser = data.data.d;
       }, function (error) { }),
    ]);

    allPromise.then(function () {
        $http({
            method: 'GET',
            url: '/service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 3;
                
                if ($scope.CIFInvestor.FATCA1 == 'Ya' || $scope.CIFInvestor.FATCA2 == 'Ya' || $scope.CIFInvestor.FATCA3 == 'Ya')
                {
                    $scope.chkquestionfatca = false;
                }

                if ($scope.CIFInvestor.InvestmentObjectives == 0)
                    $scope.CIFInvestor.InvestmentObjectives = '';
               
            } // END IF data.data.d
        }, function (error) { });
    });

    $scope.prepareData = function () {
        console.log($scope.CIFInvestor);

        if ($scope.chkquestion1) {
            if ($scope.chkquestion1 = true) {
                $scope.CIFInvestor.Question1 = 'Ya';
            }
        } else {
            $scope.CIFInvestor.Question1 = 'Tidak';
            $scope.CIFInvestor.Question1_Text = '';
        }

        if ($scope.chkquestion2) {
            if ($scope.chkquestion2 = true) {
                $scope.CIFInvestor.Question2 = 'Ya';
            }
        } else {
            $scope.CIFInvestor.Question2 = 'Tidak';
            $scope.CIFInvestor.Question2_Text = '';
        }

        if ($scope.chkquestion3) {
            if ($scope.chkquestion1 = true) {
                $scope.CIFInvestor.Question3 = 'Ya';
            }
        } else {
            $scope.CIFInvestor.Question3 = 'Tidak';
            $scope.CIFInvestor.Question3_Text = '';
        }

        if ($scope.chkquestion4) {
            if ($scope.chkquestion4 = true) {
                $scope.CIFInvestor.Question4 = 'Ya';
            }
        } else {
            $scope.CIFInvestor.Question4 = 'Tidak';
            $scope.CIFInvestor.Question4_Text = '';
        }

        if ($scope.chkquestionfatca)
        {
            if ($scope.chkquestionfatca = true)
            {

                $scope.CIFInvestor.FATCA1 = 'Tidak';
                $scope.CIFInvestor.FATCA2 = 'Tidak';
                $scope.CIFInvestor.FATCA3 = 'Tidak';
            }
        }

    }

    $scope.submit = function () {
        $scope.prepareData();
        var finished = 0;

        $scope.working = true;

        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        .then((result) => {
            if (result.value) {
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                $http({
                    method: 'POST',
                    url: '/service/client.svc/SaveCIF',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {
                    if (data.data.d.result) {
                        swal.close();
                        $window.location.href = "#/cif/data-pernyataan";
                    }
                    else {
                        swal('Failed', data.data.d.message, 'error');
                    }
                }, function (error) {
                    swal('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: '/service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };


});


